import { DEFAULT_PROJECTS_SORT_BY } from "@components/projects/projects-sort-constants";
import { getProjectsSortBy, isProjectsSortField } from "@components/projects/projects-sort-utils";
import { convertGridSortModelToSortBy } from "@utils/sort-utils";
import { requiredProjectTableColumns } from "@pages/projects/projects-utils";

/**
 * @returns a valid projects `sortBy` option query param of the /v3/projects endpoint from the passed
 * projects table sort model, or the default criteria if the the passed sort model does not map to
 * a valid `sortBy` option.
 * @param gridSortModel Projects table sort model
 */
export function getSortByFromGridSortModel(gridSortModel) {
  return convertGridSortModelToSortBy(gridSortModel, {
    defaultSortBy: DEFAULT_PROJECTS_SORT_BY,
    isValidSortField: isProjectsSortField,
    getSortBy: getProjectsSortBy
  });
}
const requiredProjectTableColumnsSet = new Set(requiredProjectTableColumns);

/** Type guard to check if a string is a valid ProjectsTableColumnField */
export function isProjectsTableColumnField(key) {
  return requiredProjectTableColumnsSet.has(key);
}